import React from "react";
import { observer } from "mobx-react-lite";
import { InputGroup, Intent } from "@blueprintjs/core";
import { FormGroupWithRequired } from "./Components";
import { ITextAttrEditorProps, EditorWithFormGroup } from "./_types";

// TextAttrEditor
export const TextAttrEditor = observer(<D, K extends keyof D>(props: ITextAttrEditorProps<D, K>) => {
	const { store, ...rest } = props;

	// Change handler
	const onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
		if (props.inputGroupProps?.onChange) props.inputGroupProps.onChange(ev);
		else {
			let value = ev.target.value as any;
			if (props.valueParser) value = props.valueParser(value);
			store.set(props.name, value);
		}
	};

	// --

	return <InputGroup onChange={onChange} value={(store.data[props.name] as string) ?? ""} {...rest.inputGroupProps} name={rest.name as string} />;
});

// TextAttrEditorGrouo
export const TextAttrEditorGroup = <D, K extends keyof D>(props: EditorWithFormGroup<ITextAttrEditorProps<D, K>>) => {
	// --

	return (
		<FormGroupWithRequired required={props.inputGroupProps.required} {...props.formGroupProps}>
			<TextAttrEditor inputGroupProps={props.inputGroupProps} store={props.store} name={props.name} />
		</FormGroupWithRequired>
	);
};

// TextAttrEditorGrouo
export const TextAttrEditorGroupWithError = observer(<D, K extends keyof D>(props: EditorWithFormGroup<ITextAttrEditorProps<D, K>>) => {
	const error = props.store.validation.errors.get(props.name);
	const intent: Intent = error ? "danger" : props.inputGroupProps.intent;

	// --

	return (
		<FormGroupWithRequired
			required={props.inputGroupProps.required}
			{...props.formGroupProps}
			helperText={<span dangerouslySetInnerHTML={{ __html: error ?? (props.formGroupProps.helperText as any) ?? "&nbsp;" }} />}
			intent={intent}
		>
			<TextAttrEditor
				inputGroupProps={{
					...props.inputGroupProps,
					intent,
				}}
				valueParser={props.valueParser}
				store={props.store}
				name={props.name}
			/>
		</FormGroupWithRequired>
	);
});
